import styled, { css } from 'styled-components';

export const Divider = styled.section`
	border-bottom: ${(props) => `1px solid ${props.theme.color.gray[10]}`};
`;

export const FlexCenter = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

interface IScrollable {
	height: string;
	hideScrollbar?: boolean;
}

export const Scrollable = styled.div<IScrollable>`
	height: ${(props) => props.height};
	
	overflow-x: hidden;

	${(props) =>
		props.hideScrollbar
			? css`
					/* Hide scrollbar for Chrome, Safari and Opera */
					::-webkit-scrollbar {
						display: none;
					}
					/* Hide scrollbar for firefox and edge */
					scrollbar-width: none;
					-ms-overflow-style: none;
			  `
			: css`
					/* width */
					&::-webkit-scrollbar {
						width: 4px;
					}

					/* Track */
					&::-webkit-scrollbar-track {
						background-color: ${(props) => props.theme.color.gray[20]};
					}

					/* Handle */
					&::-webkit-scrollbar-thumb {
						background: ${(props) => props.theme.color.gray[40]};
					}

					/* Handle on hover */
					&::-webkit-scrollbar-thumb:hover {
						/* background: #b30000; */
					}
			  `}
`;

interface IIconWrapper {
	isLoading?: boolean;
}
export const IconWrapper = styled.button<IIconWrapper>`
	@keyframes spinner {
		0% {
			transform: translate3d(-50%, -50%, 0) rotate(0deg);
		}
		100% {
			transform: translate3d(-50%, -50%, 0) rotate(360deg);
		}
	}
	${(props) =>
		props.isLoading &&
		css`
			&::before {
				animation: 1.5s linear infinite spinner;
				animation-play-state: inherit;
				border: ${(props) => `2px solid ${props.theme.color.gray[40]}`};
				border-bottom-color: ${(props) => props.theme.color.danger};
				border-radius: 50%;
				content: '';
				height: 85%;
				width: 85%;
				position: absolute;

				left: 50%;
				top: 50%;
				transform: translate3d(-50%, -50%, 0);
				will-change: transform;
			}
		`}
	position: relative;
	display: inline-flex;
	align-items: center;
	-webkit-box-pack: center;
	justify-content: center;
	position: relative;
	background-color: transparent;
	outline: 0px;
	border: 0px;
	margin: 0px;
	cursor: pointer;
	user-select: none;
	vertical-align: middle;
	appearance: none;
	text-decoration: none;
	text-align: center;
	flex: 0 0 auto;
	font-size: 1.5rem;
	padding: 8px;
	border-radius: 50%;
	overflow: visible;
	color: rgba(0, 0, 0, 0.54);
	transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	padding: ${(props) => props.theme.spacing.sm2};
	&:hover {
		background-color: rgba(0, 0, 0, 0.04);
	}
`;
